module.exports = __webpack_public_path__ + "img/antonplepel.88189cfe.jpg";